import { c as _c } from "react/compiler-runtime";
import { useKeyEvent, useOnClickOutside, zIndices } from '@newfront-insurance/core-ui';
import { useAnalytics } from '@newfront-insurance/data-layer-client';
import { datadogRum } from '@newfront-insurance/dd-rum';
import * as React from 'react';
import type { JSX } from 'react';
import styled from 'styled-components';
import { SearchContainer } from './components/container';
import { RenderCardPreview } from './helpers/index';
import { useItemResultRouting } from './hooks/use-item-result-routing';
import { useGlobalSearch } from './hooks/use-search';
interface Props {
  setIsSearchActive: React.Dispatch<React.SetStateAction<boolean>>;
}
export function GlobalSearch(t0) {
  const $ = _c(28);
  const {
    setIsSearchActive
  } = t0;
  const analytics = useAnalytics();
  const {
    handleSearch,
    isLoading,
    results,
    suggestions,
    handleReset,
    handleSelectSuggestion,
    error
  } = useGlobalSearch();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = React.createRef();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const innerRef = t1;
  let t2;
  if ($[1] !== setIsSearchActive) {
    t2 = () => {
      setIsSearchActive(false);
    };
    $[1] = setIsSearchActive;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useOnClickOutside(innerRef, t2);
  let t3;
  if ($[3] !== setIsSearchActive) {
    t3 = () => setIsSearchActive(false);
    $[3] = setIsSearchActive;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useKeyEvent("Escape", t3, t4);
  const {
    goToItemResultPage
  } = useItemResultRouting();
  let t5;
  if ($[6] !== analytics || $[7] !== handleSearch || $[8] !== results) {
    t5 = value => {
      handleSearch(value);
      analytics.track({
        event: "global_search_input",
        properties: {
          value,
          results: results?.map(_temp)
        }
      });
    };
    $[6] = analytics;
    $[7] = handleSearch;
    $[8] = results;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== analytics || $[11] !== goToItemResultPage || $[12] !== setIsSearchActive) {
    t6 = async (data, rank) => {
      setIsSearchActive(false);
      await goToItemResultPage(data.routing);
      datadogRum.addAction("Global search result selected", {
        searchResult: data,
        rank
      });
      analytics.track({
        event: "global_search_result_selected",
        properties: {
          id: data.id,
          type: data.type,
          rank
        }
      });
    };
    $[10] = analytics;
    $[11] = goToItemResultPage;
    $[12] = setIsSearchActive;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== handleSelectSuggestion) {
    t7 = async suggestion => {
      await handleSelectSuggestion(suggestion);
      datadogRum.addAction("Global search result selected (suggestion)", {
        suggestion
      });
    };
    $[14] = handleSelectSuggestion;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleReset) {
    t8 = () => {
      handleReset();
    };
    $[16] = handleReset;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== error || $[19] !== isLoading || $[20] !== results || $[21] !== setIsSearchActive || $[22] !== suggestions || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = <StyledOverlay><SearchContainer ref={innerRef} isSearching={isLoading} maxWidth="700px" onChange={t5} onClickResultItem={t6} onSetIsSearchActive={setIsSearchActive} onSelectSuggestion={t7} onReset={t8} onRenderPreview={RenderCardPreview} placeholder="Search..." results={results} suggestions={suggestions} error={error} /></StyledOverlay>;
    $[18] = error;
    $[19] = isLoading;
    $[20] = results;
    $[21] = setIsSearchActive;
    $[22] = suggestions;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
function _temp(result) {
  return {
    id: result.id,
    type: result.type
  };
}
const StyledOverlay = styled.div`
  background: rgb(0, 0, 0, 0.3);
  transition: background ease-in-out 0.4ms;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndices.overlay};
  padding: 7px;
`;